import React from "react";

export const CheckIcon = ({ color = "#05945B" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="20" height="20" rx="10" fill={color} />
      <path
        d="M13.9483 6.84471C13.9014 6.79783 13.8378 6.77149 13.7715 6.77148C13.7052 6.77148 13.6416 6.79782 13.5947 6.8447L8.87501 11.5642L6.78033 9.46969C6.73344 9.42281 6.66985 9.39647 6.60355 9.39648C6.53724 9.39648 6.47366 9.42282 6.42677 9.46971L5.7197 10.1768C5.62207 10.2745 5.62208 10.4328 5.71972 10.5304L8.34472 13.1552C8.63761 13.448 9.11245 13.448 9.40534 13.1552L14.6553 7.90539C14.753 7.80776 14.753 7.64947 14.6553 7.55183L13.9483 6.84471Z"
        fill="white"
        stroke="white"
        strokeWidth="0.5"
        strokeLinejoin="round"
      />
    </svg>
  );
};
